// The v2 PT/EN pill switch, driven by the site's own language state.
export default function LangSwitch({ isEnglish, onToggle }) {
  return (
    <button
      onClick={onToggle}
      aria-label={isEnglish ? 'Mudar para Português' : 'Switch to English'}
      className="relative flex h-9 w-[78px] shrink-0 items-center rounded-full bg-white/[0.04] p-1 ring-1 ring-white/10 transition hover:ring-white/25"
    >
      <span
        className="bg-brand absolute top-1 h-7 w-[34px] rounded-full shadow-[0_0_18px_rgba(45,92,255,0.6),inset_0_1px_0_rgba(255,255,255,0.4)] transition-transform duration-500"
        style={{ transform: `translateX(${isEnglish ? 36 : 0}px)`, transitionTimingFunction: 'cubic-bezier(.68,-0.4,.32,1.4)' }}
      />
      <span className={`label relative z-10 w-[34px] text-center text-[0.65rem] transition-colors ${isEnglish ? 'text-white/45' : 'text-white'}`}>PT</span>
      <span className={`label relative z-10 ml-0.5 w-[34px] text-center text-[0.65rem] transition-colors ${isEnglish ? 'text-white' : 'text-white/45'}`}>EN</span>
    </button>
  )
}
